<template>
	<div class="loadItem">
		<div class="loadHead">
			<div class="title">{{ loadTitle }}</div>
			<div class="contract_btn">
				<button @click="onAddItem" type="button" class="mainBtn mainBtn-text">
          <span class="btnIco">
              <svg-sprite icon-id="plus" width="20" height="20"></svg-sprite>
          </span>
					<span class="btnText">{{ loadAddNew }}</span>
				</button>
			</div>
		</div>

		<div class="loadMain" >
			<pickup-delivery-item
					v-for="(item, index) in load[loadKey]"
					:key="item.id != null ? item.id : index"
					:index="index"
					:item="item"
					:default-location="defaultLocation"
					:errors="errors"
					@updateDeleteItem="onDeleteItem(index)"
					@updateAutocomplete="onAutocomplete($event, index)"
					@updateInput="onInput($event, index)"
					@updateSearchText="onSearchText($event, index)"
					@updateTime="onTime($event, index)"
			></pickup-delivery-item>
		</div>
	</div></template>

<script>
import PickupDeliveryItem from "@/components/Dispatch/Trips/DialogTrip/Load/PickupDelivery/PickupDeliveryItem.vue";

import { PAGE } from "@/constants/constants";

export default {
	name: PAGE.TRIP_PICKUP_DELIVERY,
	components: {
		PickupDeliveryItem,
	},
	props: {
		loadTitle: String,
		loadAddNew: String,
		loadKey: String,
		load: Object,
		defaultLocation: Array,
		errors: Object,
	},
	computed: {

	},
	data() {
		return {
			flag: PAGE.TRIP_PICKUP_DELIVERY,
		};
	},
	methods: {
		onAddItem() {
			this.$emit('updateAddItem', this.loadKey);
		},
		onDeleteItem(index) {
			this.$emit('updateDeleteItem', { index, flag: this.loadKey });
		},
		onAutocomplete(args, index) {
			this.$emit('updateAutocomplete', { args, index, flag: this.loadKey });
		},
		onInput(args, index) {
			this.$emit('updateInput', { args, index, flag: this.loadKey });
		},
		onSearchText(args, index) {
			this.$emit('updateSearchText', { args, index, flag: this.loadKey });
		},
		onTime(args, index) {
			this.$emit('updateTime', { args, index, flag: this.loadKey });
		},
	},
};
</script>

<style lang="scss">
.loadMain {
	.pagination {
		padding: 20px 0 10px;
	}
}
</style>
<style scoped lang="scss">
@import "../loadItem";
</style>
